import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "payment-select-window" }
const _hoisted_2 = {
  class: "payment-popup",
  ref: "paymentSelect"
}
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-sub-header" }
const _hoisted_5 = { class: "payment-method-container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "payment-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "payment-icon add-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9 0V9H0V11H9V20H11V11H20V9H11V0H9Z",
      fill: "#6C6C6C"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_9 = { class: "payment-description center" }
const _hoisted_10 = { class: "add-payment" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.withdraw ? "Accounts" : "Payment Methods"), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, _toDisplayString($props.withdraw ? "Add a new account" : "Add a new payment method"), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.paymentMethods, (payment) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (payment.type == 'credit' || payment.type == 'bank')
              ? (_openBlock(), _createBlock($setup["PaymentMethod"], {
                  key: 0,
                  payment: payment,
                  onClick: ($event: any) => ($setup.selectInfo(payment))
                }, null, 8 /* PROPS */, ["payment", "onClick"]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _createElementVNode("div", {
          class: "default-payment-method",
          onClick: _withModifiers($setup.addPaymentMethod, ["stop"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString($props.withdraw ? "Add an account" : "Add Payment Method"), 1 /* TEXT */)
            ])
          ])
        ], 8 /* PROPS */, _hoisted_6)
      ])
    ], 512 /* NEED_PATCH */)
  ]))
}